import React from "react";
import { Box, Button, Divider, IconButton, Typography, Tooltip } from "@mui/material";
import PsychologyOutlined from "@mui/icons-material/PsychologyOutlined";
import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import NotificationsOutlined from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import HelpOutlineOutlined from "@mui/icons-material/HelpOutlineOutlined";
import { Link as RouterLink } from "react-router-dom";
import FlexBetween from "components/global/FlexBetween";

const iconBtnSx = (theme) => ({
  width: 36,
  height: 36,
  borderRadius: "9px",
  color: theme.palette.primary.main,
  transition: "background-color 160ms ease, color 160ms ease, transform 160ms ease",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    transform: "translateY(-1px)",
  },
  "&.Mui-disabled": {
    color: theme.palette.action.disabled,
  },
});

const NavbarActions = ({
  isLoggedIn,
  isCopilotOpen,
  onToggleCopilot,
  onToggleDarkMode,
  onOpenPreferences,
  configRef,
  theme,
}) => {
  const accent = theme.palette.primary.main;

  return (
    <FlexBetween gap=".35rem">
      <Button
        onClick={onToggleCopilot}
        disabled={!isLoggedIn}
        sx={{
          display: "flex",
          alignItems: "center",
          textTransform: "none",
          gap: 0.75,
          px: 1.25,
          py: 0.75,
          borderRadius: "10px",
          border: `1px solid ${isCopilotOpen ? accent : "transparent"}`,
          backgroundColor: isCopilotOpen
            ? `${accent}14`
            : "transparent",
          transition: "all 160ms ease",
          "&:hover": {
            backgroundColor: isCopilotOpen
              ? `${accent}22`
              : theme.palette.action.hover,
            borderColor: accent,
          },
        }}
      >
        <PsychologyOutlined sx={{ fontSize: 20, color: accent }} />
        <Typography
          fontWeight={600}
          fontSize="0.95rem"
          letterSpacing="0.02em"
          sx={{ color: accent, lineHeight: 1 }}
        >
          Copilot
        </Typography>
      </Button>

      <Divider
        orientation="vertical"
        flexItem
        sx={{ mx: 0.5, my: 1, borderColor: theme.palette.divider }}
      />

      <Tooltip title={theme.palette.mode === "dark" ? "Light mode" : "Dark mode"}>
        <IconButton onClick={onToggleDarkMode} aria-label={theme.palette.mode === "dark" ? "Switch to light mode" : "Switch to dark mode"} sx={iconBtnSx(theme)}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlined sx={{ fontSize: 20 }} />
          ) : (
            <LightModeOutlined sx={{ fontSize: 20 }} />
          )}
        </IconButton>
      </Tooltip>

      <Tooltip title="Notifications">
        <Box component="span">
          <IconButton aria-label="Notifications" disabled={!isLoggedIn} sx={iconBtnSx(theme)}>
            <NotificationsOutlined sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
      </Tooltip>

      <Tooltip title="Preferences">
        <Box component="span">
          <IconButton
            ref={configRef}
            aria-label="Open preferences"
            onClick={onOpenPreferences}
            disabled={!isLoggedIn}
            sx={iconBtnSx(theme)}
          >
            <SettingsOutlined sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
      </Tooltip>

      <Tooltip title="Help">
        <IconButton
          aria-label="Open help"
          component={RouterLink}
          target="_blank"
          to="catalogue/663a19db1242002d9120d634"
          sx={iconBtnSx(theme)}
        >
          <HelpOutlineOutlined sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
    </FlexBetween>
  );
};

export default NavbarActions;
